import { render, staticRenderFns } from "./AdminStatistics.vue?vue&type=template&id=11197b0e&scoped=true"
import script from "./AdminStatistics.vue?vue&type=script&lang=js"
export * from "./AdminStatistics.vue?vue&type=script&lang=js"
import style0 from "./AdminStatistics.vue?vue&type=style&index=0&id=11197b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11197b0e",
  null
  
)

export default component.exports